<template lang="pug">
  .wrapper-header-timesheet(v-shortkey.once="shortcuts", @shortkey="handleHotKeys")

    FixedArea
      template(v-slot:default="{fixed}")
        LineActions.line-actions(key="lineActions")

        .wrapper-simple-header(v-show="!showLineActions", key="header", :class="gridTemplateHeader")
          .companies-employees-group.two-columns(v-if="!isMine")
            .items-slider
              RadioSlider(
                :items="categories.items",
                :current="categories.items.findIndex(i => i.id === categories.selected.id)",
                @selected="openItemsSelector"
              )

            .items-selector
              PMultiSelect(
                ref="itemSelector"
                labelItem="name"
                :title="categorieSelected.name"
                :forcedPlaceholder="forcedPlaceholder"
                :useState="categorieSelected.useState"
                :useCommon="categorieSelected.common"
                :disabled="!categories.selected"
                @dblclick="consult"
                :usaPaginacao="usaPaginacao"
              )

          .date
            DateSlider(v-if="type", :kind="type", @change="loadSheet")

          GuideModal

          .operations

          .consult(v-if="!isMine")
            PButton(color="success", size="md", @click="consult" :block="true")
              | buscar

          .employee-name-info(v-if="currentEmployeeInfo && currentEmployeeInfo.employee")

            .prev(v-show="queueEmployees.length > 1 && queueCurrentIndex !== 0")
              img.arrow-img.to-click(
                src="../../../../../static/images/arrow_down.svg"
                @click="prevEmployee"
                title="Tecla de atalho: q"
              )

            label.empname.fs-21
              span.go-cadastro.icon-ptt-icons-pessoas.to-click(
                v-if="$hasPermission({module: 'cadastros', action: 'get'})"
                v-uiv-tooltip="'Ir para o cadastro'"
                @click="goEmployeeOrCompanyInfo('employee', currentEmployeeInfo.employee.id)"
              )
              | {{ currentEmployeeInfo.employee.code || '00000'}}
              | {{ currentEmployeeInfo.employee.funct ? '|' : '' }}
              | {{ currentEmployeeInfo.employee.funct }}
              | {{ '| ' + currentEmployeeInfo.employee.name }} &nbsp;

            span.count.fs-13(v-if="currentEmployeeInfo.total > 1")
              | {{ currentEmployeeInfo.position }}/{{ currentEmployeeInfo.total }}

            .empinfo.fs-15(
              @click="goToOne($event, currentEmployeeInfo.company, 'company')"
              :class="{ 'to-click': !isMine }"
            )
              | {{ currentEmployeeInfo.company.name }}

            .next(v-if="queueEmployees.length > 1 && queueCurrentIndex !== queueEmployees.length -1")
              img.arrow-img.to-click(
                src="../../../../../static/images/arrow_down.svg"
                @click="nextEmployee"
                title="Tecla de atalho: e"
              )

          .company-name-info(v-else-if="currentCompanyInfo")
            label.fs-21
              span.go-cadastro.icon-ptt-icons-pessoas.to-click(
                v-if="$hasPermission({module: 'cadastros', action: 'get'})"
                v-uiv-tooltip="'Ir para o cadastro'",
                @click="goEmployeeOrCompanyInfo('company', currentCompanyInfo.id)"
              )
              | {{ currentCompanyInfo.name }} &nbsp;

          .employee-name-info-carregando(v-else-if="carregandoFilaDeEmpregados")
            SkeletonBox(margin="0 0 0 0" key="carregandoFilaDeEmpregados" width="100%" height="30px")

          .order-employee-by(v-if="!isMine && categorieSelected.id === 'company'")
            span.title Ordernar {{ $wp('employee') }} por:
            label.day
              PRadio(
                :label="'por dia do ' + $wp('companyShortName')"
                v-model="typeLoadCompany"
                v-shortkey.allow=""
                option="perday"
              )

            label.employee
              PRadio(
                :label="'por ' + $wp('employee')"
                v-model="typeLoadCompany"
                v-shortkey.allow=""
                option="peremp"
              )

        SheetHeader(v-if="fixed" :showDate="type === 'employee'", :showName="type !== 'employee'")

</template>

<script>
import DateSlider from './DateSlider.vue'
import { mapGetters, mapState } from 'vuex'
import GuideModal from './GuideModal'
import { orderEmployees, range } from 'src/utils'
import Cookie from 'js-cookie'
import LineActions from 'src/components/Sheets/Sheet/LineActions/LineActions.vue'
import { shortcutsHandler, shortcuts } from './shortcuts'
import RadioSlider from 'src/common/Tabs/RadioSlider'
import FixedArea from 'src/common/FixedArea'
import SheetHeader from 'src/components/Sheets/Sheet/SheetHeader'

export default {
  inject: ['changeFocusToPt'],
  data () {
    return {
      categories: {
        selected: null,
        items: [
          { name: this.$wp('companyShortName'), id: 'company', common: 'companies/onlyActive', useState: 'timesheet/header/companies' },
          { name: this.$wp('employee'), id: 'employee', common: 'employees/onlyNotFired', useState: 'timesheet/header/employees' },
          { name: 'grupos', id: 'userGroup', common: 'userGroups', useState: 'timesheet/header/userGroups' }
        ]
      },
      shortcuts
    }
  },
  created () {
    this.typeEmployeeOrder = Cookie.get('typeEmployeeOrder') || 'name'
    this.typeLoadCompany = Cookie.get('typeLoadCompany') || 'perday'

    this.categories.selected = this.categories.items[0]
  },
  computed: {
    ...mapState('sheet/toolBox', ['configs']),
    ...mapState('timesheet/header', [
      'queueCurrentIndex', 'employees', 'companies', 'userGroups',
      'id', 'queueEmployees', 'endDate'
    ]),
    ...mapState('timesheet', ['locking']),
    ...mapGetters('timesheet', ['buildingSheet']),
    ...mapGetters('timesheet/header', ['currentQueueEmployee']),
    ...mapGetters('timesheet/sheet', ['employeesPerId']),
    type: {
      get () { return this.$store.state.timesheet.header.type },
      set (newType) {
        this.$store.commit('timesheet/header/type', newType)
        this.$store.dispatch('timesheet/loadSheet')
      }
    },
    usaPaginacao () { return this.categories.selected.id === 'employee' },
    showLineActions () { return this.$store.state.sheet.lineActions.type !== null },
    toolBoxConfigs () {
      return this.$store.state.sheet.toolBox.configs
    },
    forcedPlaceholder () {
      const companies = this.companies.selected
      const employees = this.employees.selected
      const userGroups = this.userGroups.selected

      if (companies.length || employees.length || userGroups.length) {
        return null
      }

      if (this.categories.selected.id === 'company') {
        return 'selecionar ' + this.$wp('company')
      } else if (this.categories.selected.id === 'employee') {
        return 'selecionar ' + this.$wp('employee')
      } else {
        return 'selecionar grupos'
      }
    },
    permissions () {
      return {
        recalc: { module: 'timemeasurements', action: 'post', hide: true },
        viewEmployee: { module: 'compemployee', action: 'get', hide: true },
        editWhbo: { module: 'workhourbankobjects', action: 'post', hide: true }
      }
    },
    whbOptions () {
      const ops = [
        { text: 'Adicionar', callback: this.activateWhb },
        { text: 'Remover', callback: this.removeWhb }
      ]
      if (this.type === 'employee') {
        ops.push({ text: 'Gerar Relatório', callback: this.genWHBReport })
      }
      return ops
    },
    allowChange () {
      if (this.employees.selected.length === 0 && this.companies.selected.length === 0) { return false }
      return true
    },
    currentEmployeeInfo () {
      if (this.type === 'employee' && this.queueEmployees.length) {
        const allEmpInfo = this.$store.state.common.employees.items.find(i => i.id === this.currentQueueEmployee.id)

        if (!allEmpInfo) { return null }

        return {
          employee: allEmpInfo,
          position: this.queueCurrentIndex + 1,
          total: this.queueEmployees.length,
          company: allEmpInfo.company ? allEmpInfo.company[0] : ''
        }
      }
      return null
    },
    currentCompanyInfo () {
      const companies = this.$store.state.timesheet.dataUsedToPopulate?.companies
      const companiesInStore = this.$store.state.common.companies?.items

      if (this.type === 'work-place' && companies && companies.length === 1 && companiesInStore.length > 0) {
        return companiesInStore.find(i => i.id === companies[0])
      }
      return null
    },
    loadingEmpOrCompany () {
      if (this.$store.state.timesheet.header.companies.loaded.length > 0 &&
        this.$store.state.timesheet.header.employees.loaded.length > 0) { return false }

      return this.$store.state.timesheet.header.companies.loading ||
        this.$store.state.timesheet.header.employees.loading
    },
    typeLoadCompany: {
      get () { return this.$store.state.timesheet.header.typeLoadCompany },
      set (val) {
        Cookie.set('typeLoadCompany', val)
        this.$store.commit('timesheet/header/typeLoadCompany', val)
      }
    },
    typeEmployeeOrder: {
      get () { return this.$store.state.timesheet.header.typeEmployeeOrder },
      set (val) {
        Cookie.set('typeEmployeeOrder', val)
        this.$store.commit('timesheet/header/typeEmployeeOrder', val)
      }
    },
    categorieSelected () {
      if (this.categories.selected) return this.categories.selected

      return {
        name: 'Selecionar',
        id: 0,
        common: '',
        useState: 'timesheet/header/companies'
      }
    },
    isMine () {
      return this.$store.state.userInfo.roles[0].filter === 'mine'
    },
    gridTemplateHeader () {
      if (this.isMine) {
        if (!this.currentEmployeeInfo && !this.currentCompanyInfo) return ['only-date']
        return ['mine']
      }
      return ['normal']
    },
    carregandoFilaDeEmpregados () {
      if (this.type !== 'employee') return false
      return this.$store.state.common.employees.loading
    }
  },
  methods: {
    activateVerify () {
      this.$store.commit('timesheet/header/type', 'verify')
    },
    consult () {
      const selected = this.categories.selected.id

      const canReload = this.$store.state.timesheet.dataUsedToPopulate
      const anyEmpSelected = Boolean(this.employees.selected.length)
      const anyCompSelected = Boolean(this.companies.selected.length)
      const anyGroupSelected = Boolean(this.userGroups.selected.length)

      // prevent to consult if was not previous loaded or selected items are unchanged
      if (!canReload && selected === 'employee' && !anyEmpSelected) { return }
      if (!canReload && selected === 'company' && !anyCompSelected) { return }
      if (!canReload && selected === 'userGroup' && !anyGroupSelected) { return }

      document.activeElement.blur()

      this.$store.commit(
        'timesheet/header/type',
        ({userGroup: 'user-group', company: 'work-place', employee: 'employee'})[selected]
      )

      // user didn't change any selector, so we will reload all lines
      if (canReload && !anyEmpSelected && !anyCompSelected && !anyGroupSelected) {
        this.$store.dispatch('timesheet/loadSheet')
        return
      }

      if (selected === 'employee') {
        const empsOrdered = orderEmployees(this.$store.state.timesheet.header.employees.selected,
          this.typeEmployeeOrder)
        this.$store.commit('timesheet/header/type', 'employee')
        this.$store.commit('timesheet/header/queueEmployees', empsOrdered)
        this.$store.dispatch('timesheet/header/nextEmployee', { fromStart: true })
      } else if (selected === 'userGroup') {
        this.$store.commit('timesheet/header/type', 'user-group')
        this.loadSheet(null, false)
      } else {
        this.$store.commit('timesheet/header/employees', { selected: [] })
        this.loadSheet(null, this.type === 'employees')
      }
    },
    prevEmployee () {
      if (this.queueCurrentIndex === 0) { return }
      this.$store.dispatch('timesheet/header/prevEmployee')
    },
    nextEmployee () {
      if (this.queueEmployees.length - 1 === this.queueCurrentIndex) { return }
      this.$store.dispatch('timesheet/header/nextEmployee')
    },
    async loadSheet (baseDate = null, closingSheet = false) {
      if (this.populating || this.loading) {
        return
      }
      const someQueueIsNotEmpty = this.$store.getters['sheet/promiseQueueIsNotEmpty']
      if (someQueueIsNotEmpty) {
        const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
        if (!answer) {
          return
        }
      }
      this.$store.commit('sheet/clearAllPromiseQueues')
      this.$store.dispatch('timesheet/header/calcPeriod', { baseDate, closingSheet })
    },

    handleHotKeys (event) {
      if (this.locking) { return }

      if (this.queueCurrentIndex === 0 && event.srcKey === 'prevEmployee') { return }
      if ((this.queueEmployees.length - 1 === this.queueCurrentIndex) && event.srcKey === 'nextEmployee') { return }

      return shortcutsHandler.bind(this)(event)
    },

    focusFirstPt () {
      this.changeFocusToPt([0, 0], null, true)
    },

    recalcAll () {
      const lines = this.$store.getters['timesheet/sheet'].lines
      this.$store.dispatch('sheet/recalcLines', range(0, lines.length - 1))
    },

    goEmployeeOrCompanyInfo (type, id) {
      this.$router.push(`/${type}/${id}`)
    },

    async handleReport (apiCall) {
      try {
        const response = await apiCall
        this.$swal({
          type: response.body.success ? 'success' : 'info',
          text: response.body.success || response.body.info
        })
      } catch (e) {
        this.$swal({
          type: 'error',
          title: 'Aconteceu um erro',
          text: e.data && e.data.error ? e.data.error : ''
        })
      }
    },

    activateWhb () {
      this.$store.dispatch('sheet/addRemoveWHBSelectedLines', 'add')
    },
    removeWhb () {
      this.$store.dispatch('sheet/addRemoveWHBSelectedLines', 'delete')
    },
    genWHBReport () {
      const params = {
        employeeId: this.$store.getters['timesheet/sheet'].lines[0].employee.id,
        companyId: false,
        year: this.endDate.getFullYear(),
        month: this.endDate.getMonth() + 1,
        just: true
      }
      this.handleReport(this.$API.folhaWHB.get(params))
    },
    goToOne (event, item, type) {
      if (this.verifyMode) { return }
      if (type === 'company' && this.isMine) { return }

      this.categories.selected = this.categories.items.find(i => i.id === type)
      this.$store.commit(
        `timesheet/header/${({'company': 'companies', 'employee': 'employees', 'userGroup': 'userGroups'})[type]}`,
        {selected: [item]}
      )
      this.consult()
    },
    openItemsSelector (item) {
      this.categories.selected = item
      this.$refs.itemSelector.open()
    }
  },
  components: {
    DateSlider, GuideModal, LineActions, RadioSlider, FixedArea, SheetHeader
  }
}
</script>

<style scoped lang="scss">
.wrapper-header-timesheet {
  background-color: var(--front-background-color);
  .employee-name-info {
    grid-area: name-info;
    display: grid;
    grid-template-columns: 0.1fr 0.7fr 1fr 0.7fr 0.1fr;
    grid-template-rows: auto;
    grid-template-areas:
      "prev count empname empinfo next";

    button {
      width: 30%;
    }

    .code {
      grid-area: emp-code;
      text-align: center;
    }

    .empname {
      grid-area: empname;
      justify-content: center;
      font-weight: 400;
      text-align: center;
      margin: 0;

      .go-cadastro {
        margin: 10px 4px 0 0;
      }
    }

    .prev {
      grid-area: prev;
      text-align: center;
      justify-self: flex-start;
      align-self: center;
    }
    .next {
      grid-area: next;
      text-align: center;
      justify-self: flex-end;
      align-self: center;
    }
    .count {
      grid-area: count;
      text-align: center;
      justify-self: flex-start;
      color: #4d4d4d;
      align-self: center;
      padding-top: 1px;
    }
    .empinfo {
      grid-area: empinfo;
      text-align: center;
      justify-self: flex-end;
      align-self: center;
      color: #4d4d4d
    }
  }
  .company-name-info {
    .go-cadastro {
      margin: 10px 4px 0 0;
    }
  }
  .order-employee-by {
    grid-area: order-employees;
    display: grid;
    grid-template-columns: 1fr auto auto;
    column-gap: 6px;
    justify-items: end;
    margin-top: 10px;
  }
}
</style>

<style scoped>
.wrapper-simple-header {
  display: grid;
  grid-template-columns: 1fr 0.5fr 1fr 1.5fr 0.3fr;
  grid-template-rows: auto auto auto;
  grid-column-gap: 10px;
}

.only-date {
  margin-top: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-areas:
    ". date date date ."
    ". . . . ."
}
.mine {
  margin-top: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-areas:
    "date . . . ."
    "name-info name-info name-info name-info name-info"
}
.normal {
  grid-template-areas:
    "date selectors-comp-emp-group selectors-comp-emp-group selectors-comp-emp-group consult"
    "name-info name-info name-info name-info name-info"
    ". . . order-employees order-employees"
}

.separate {grid-area: hr}

.select-type-timesheet {
  grid-area: select-type;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  justify-items: center;
}
.select-type-timesheet .selects { grid-area: selects }
.ptskinds{ grid-area: ptskinds }
.select-type-timesheet .confirm { grid-area: confirm }

.select-type-timesheet > label {
  margin-left: 10px;
}

.consult {
  grid-area: consult;
  /* max-height: 40px;
  padding-left: 10px; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow-img {
  height: 15px;
}

.prev .arrow-img {
  transform: rotate(90deg);
  vertical-align: middle;
}

.next .arrow-img {
  transform: rotate(-90deg);
  vertical-align: middle;
}

.companies-selector {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto 30px;
}
.companies-selector > .form-group {
  margin-bottom: -5px;
}

.wrapper-simple-header .date { grid-area: date; display: flex; align-self: center; }
.companies-employees-group {
  height: 71px;
  display: grid;
  grid-column-gap: 10px;
  align-items: flex-end;
  grid-area: selectors-comp-emp-group;
  width: 100%;
}

.three-columns {grid-template-columns: 1fr 1fr 1fr;}
.two-columns {grid-template-columns: 1fr 1fr;}

.operations {
  grid-column-start: 1;
  padding: 5px 0 5px 0;
  grid-column-end: 6;
  align-items: center;
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  text-align: right;
}
.operations > button {
  margin: 0 5px 0 5px;
}
.whb-option {
  text-align: left; min-width: 200px; padding: 0 5px 0 5px;
}
.whb-option:hover {
  background-color: gainsboro;
}

.company-name-info {
  grid-area: name-info;
  width: 100%;
  text-align: center;
}

.employee-name-info-carregando {
  grid-area: name-info;
  width: 100%;
}

.items-slider {
  align-self: center;
  /* overflow: hidden; */
}

.items-selector {
  align-self: center;
}
</style>
